module.exports = __webpack_public_path__ + "img/link.1780c2ff.jpg";